import React from 'react';
import './ProgressBar.css';

interface ProgressBarProps {
  /**
   * Text under the bar. Callers own the wording, because it is page copy: /sendcards
   * escalates it over time ("Loading available packages..." then "Building initial
   * cache...") while /search states one thing.
   */
  label?: string;
}

/**
 * An indeterminate progress bar with a label beneath it.
 *
 * Deliberately unpositioned: this renders the bar and its text and nothing else,
 * so a caller can drop it into an in-flow container or an absolutely-positioned
 * overlay without the component knowing which. /sendcards uses both.
 */
export const ProgressBar: React.FC<ProgressBarProps> = ({ label }) => (
  <>
    {/* `tm-` prefixed: a bare .progress-bar already exists globally in
        TradeCard.css:164 and silently zeroed this bar's height. See ProgressBar.css. */}
    <div className="tm-progress-bar">
      <div className="tm-progress-bar-fill tm-progress-bar-indeterminate" />
    </div>
    {label && <p className="tm-progress-bar-text">{label}</p>}
  </>
);

export default ProgressBar;
